export default {
  // Default MUI_v05: https://mui.com/material-ui/customization/default-theme/
};
